import React, { useState, useEffect } from "react";
import { useParams, useNavigate, Link, useLocation } from "react-router-dom";
import productsData from "../data/products.json";
import "bootstrap/dist/css/bootstrap.min.css"; // Ensure Bootstrap is imported
import seoFriendlySlug from "../utils/seoFriendlySlug";

const Subcategory = () => {
  const isUAEPath = window.location.pathname.startsWith("/uae");
  const currentLocation = useLocation();

  const basePath = currentLocation.pathname.startsWith("/uae") ? "/uae/" : "/";
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const { category, subcategory } = useParams();
  const decodeCategoryName = category.replace(/-/g, " ");
  const decodeSubCategoryName = subcategory.replace(/-/g, " ");
  const [categoryData, setCategoryData] = useState(null);
  const [selectedSubCategoryData, setSelectedSubCategoryData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const foundCategory = productsData.products.find((product) => {
      return (
        product.categoryName.toLowerCase() === decodeCategoryName.toLowerCase()
      );
    });
    if (foundCategory) {
      setCategoryData(foundCategory);

      const foundSubCategory = foundCategory.subCategories.find((subCat) => {
        // console.log(
        //   "decodeCategoryName",
        //   subCat.subCategoryName.toLowerCase().replace(/[-/]/g, " "),
        //   decodeSubCategoryName.toLowerCase()
        // );
        return (
         seoFriendlySlug(subCat.subCategoryName) === seoFriendlySlug(subcategory)
        );
      });
      // console.log("foundSubCategory", foundSubCategory)
      setSelectedSubCategoryData(foundSubCategory);
    }
  }, [decodeCategoryName, decodeSubCategoryName]);

  const handleProductClick = (productName) => {
    const encodedCategory = encodeURIComponent(category);
    const encodedSubCategory = encodeURIComponent(subcategory);
    const encodedProduct = encodeURIComponent(productName).toLowerCase().replace(/%2c/g, "-");
    console.log("encodedProduct", encodedProduct)
    navigate(
      `${basePath}market-place/${encodedCategory}/${encodedSubCategory}/${seoFriendlySlug(encodedProduct)}`
    );
  };

  return (
    <div className="container">
      {/* Breadcrumb Navigation */}
      <div className="breadcrumbs" style={{ marginBottom: "3rem" }}>
        <Link
          to={`${basePath}market-place/${encodeURIComponent(category)}`}
          onClick={scrollToTop}
          className="text-dark"
        >
          {decodeCategoryName}
        </Link>
        <span className="fw-bold"> | </span>
        <Link
          to={`${basePath}market-place/${encodeURIComponent(
            category
          )}/${encodeURIComponent(subcategory)}`}
          onClick={scrollToTop}
          className="text-danger"
        >
          {decodeSubCategoryName}
        </Link>
      </div>

      {/* Category Heading */}
      <div className="text-center mb-4"></div>

      {/* Subcategory and Products */}
      <div className="p-3">
        {selectedSubCategoryData ? (
          <div>
            {/* Products Display */}
            <div className="d-flex flex-wrap justify-content-center">
              {selectedSubCategoryData.products.map((product, idx) => (
                <div
                  key={idx}
                  className="card m-2"
                  style={{
                    width: "18rem",
                    cursor: "pointer",
                    transform: "none",
                    background: "rgba(229, 229, 226, 0.4)", // Semi-transparent background
                    backdropFilter: "blur(10px)", // Glass effect with blur
                    WebkitBackdropFilter: "blur(10px)", // Safari support
                    border: "1px solid rgba(255, 255, 255, 0.2)", // Light border to enhance effect
                    borderRadius: "10px", // Rounded corners
                  }}
                  onClick={() => {
                    handleProductClick(product.productName);
                    scrollToTop();
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.transform = "scale(1)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.transform = "scale(1)")
                  }
                >
                  <div
                    className="card-img-top"
                    style={{
                      backgroundImage: `url(${require(`../assets/products/${product.productimg}`)})`,
                      height: "250px",
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      transform: "none",
                    }}
                  ></div>

                  <div className="card-body d-flex flex-column text-center">
                    <h3 className="card-title">{product.productName}</h3>
                    <Link to={`/market-place/${encodeURIComponent(category)}/${encodeURIComponent(subcategory)}/${encodeURIComponent(product.productName)}`}
                      onClick={scrollToTop}
                      className="card-text mt-auto text-decoration-none"
                    >
                      Know More
                      {/* {seoFriendlySlug('/ultracr802e%2fm')} */}
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <p>Loading subcategory details...</p>
        )}
      </div>
    </div>
  );
};

export default Subcategory;
